/**
 * @desc 删除事件
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** id */
  id: number;
}

export function request(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/event/{id}/delete',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/event/{id}/delete',

    params,
  });
}
